<div class="position-relative date-range-wrapper">
  <div class="input-group input-group-sm" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <input type="text" class="form-control form-control-sm" readonly [value]="displayText" 
         (click)="toggle()" style="cursor: pointer; font-size: 0.75rem;">
    <button *ngIf="startDate || endDate" class="btn btn-outline-secondary btn-sm" type="button" (click)="clear()">
    &times;
  </button>
  <button class="btn btn-outline-secondary btn-sm" type="button" (click)="toggle()">
    <fa-icon [icon]="faCalendar"></fa-icon>
  </button>
</div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    (backdropClick)="cancel()"
    (detach)="cancel()">

    <div class="card shadow date-range-popup">
      <div class="card-body p-0">
        <div class="d-flex">

          <div class="preset-sidebar p-2">
            <button class="btn btn-sm btn-light w-100 text-start mb-1" (click)="setPreset('today')">Today</button>
            <button class="btn btn-sm btn-light w-100 text-start mb-1" (click)="setPreset('yesterday')">Yesterday</button>
            <button class="btn btn-sm btn-light w-100 text-start mb-1" (click)="setPreset('thisMonth')">This Month</button>
            <button class="btn btn-sm btn-light w-100 text-start mb-1" (click)="setPreset('lastMonth')">Last Month</button>
            <button class="btn btn-sm btn-light w-100 text-start mb-1" (click)="setPreset('thisYear')">This Year</button>
          </div>

          <div class="p-3 flex-grow-1">
            <ngb-datepicker
              #dp
              [displayMonths]="2"
              [dayTemplate]="t"
              [maxDate]="ngbMaxDate"
              outsideDays="hidden"
              (dateSelect)="onDateSelect($event)">
            </ngb-datepicker>

            <ng-template #t let-date let-focused="focused" let-disabled="disabled">
              <span
                  class="custom-day"
                  [class.focused]="focused"
                  [class.range]="isRange(date)"
                  [class.faded]="isInside(date)"
                  [class.disabled]="disabled"
                  (mouseenter)="hoveredDate = date"
                  (mouseleave)="hoveredDate = null">
                  {{ date.day }}
              </span>
            </ng-template>

            <div class="d-flex justify-content-between mt-2">
              <button class="btn btn-sm btn-secondary" (click)="clear()">Clear</button>
              <div>
                <button class="btn btn-sm btn-secondary me-1" (click)="cancel()">Cancel</button>
                <button class="btn btn-sm btn-success" (click)="apply()">OK</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </ng-template>
</div>